import {Grid} from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import {Colors} from "../../theme/colors";
import {useTranslation} from "react-i18next";

export const RequireInfo = () => {
    const { t } = useTranslation('common');
    return (
        <Grid container direction="column" spacing={2}>
            <Grid item>
                <StyledP>{t('requireInfoField')}</StyledP>
            </Grid>
        </Grid>
    );
}

const StyledP = styled('p')`
  color: ${Colors.lightViolet};
  font-size: 0.9rem;
`;
